<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{'COMMON.DATA_VALID_REVIEW' | translate}}</h5>
    </div>
    <div *ngIf="!showApprove && !showReject" class="modal-footer footer-no-border">
      <button type="button" class="btn cancel-button" (click)="reject($event)">
        {{'COMMON.REJECT' | translate}}
      </button>
      <button type="button" class="btn btn-primary btn-primary" (click)="approve($event)">
        {{'COMMON.APPROVE' | translate}}
      </button>

    </div>
    <div class="modal-body" *ngIf="showApprove || showReject">
      <div class="text-center" *ngIf="showApprove">
        <h3>{{'DATA_QUALITY.APPROVE' | translate}}</h3>
      </div>

      <div *ngIf="showReject">
        <form class="form-wrapper">
          <div *ngFor="let question of dataQuality.questions">
            <div *ngIf="question.fieldType.toString() == 'Select'" style="margin-bottom: 2rem">
              <lib-object-dropdown [items]="question.options" [displayField]="'text'"
                (valueChange)="onOptionSelected(question, $event)" [disabled]="false" [isRequired]="true"
                [placeholder]="question.label" [customClass]="'rejection-dropdown-container'"
                #dropdown></lib-object-dropdown>

            </div>
            <div *ngIf="assignToFieldSupervisorSelected && question.label == 'Assign to User'">
              <lib-object-dropdown [items]="mobileUsers" [displayField]="'firstName'"
                (valueChange)="selectFieldAgent($event)" [placeholder]="'Select field agent'" [isRequired]="true"
                [isSearchEnabled]="true" [maxDisplayItemSize]="5" [customClass]="'rejection-dropdown-container'"
                (searchTextChange)="filterMobileUsers($event)" #assetNameDropdown></lib-object-dropdown>
            </div>
            <div *ngIf="question.fieldType.toString() == 'Checkbox'" class="checkbox-section">
              <div class="question-label">{{ question.label }}</div>
              <div class="checkbox-data">
                <div *ngFor="let option of question.options" class="checkbox-item">
                  <span class="input"><input type="checkbox" [(ngModel)]="option.isSelected"
                      [ngModelOptions]="{ standalone: true }" (change)="fieldsChange(option, question.options)"
                      value="option" /></span>
                  <span class="label">
                    {{ option.text }}
                  </span>
                </div>

              </div>

            </div>
            <div *ngIf="question.fieldType.toString() == 'Text'"
              class="form-item mb-3 data-quality-item-bottom-padding reason-text">
              <textarea id="questionVal" class="form-control" [placeholder]="question.label" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="question.inputValue">{{ question.label }}</textarea>
            </div>
            <div *ngIf="question.fieldType.toString() == 'Multiselect'" class="data-quality-item-bottom-padding">
              <lib-multi-select-dropdown class="multiselect" [items]="question.options" [label]="question.label"
                [showMore]="false" [requireApply]="false" [isDataQuality]="true">
              </lib-multi-select-dropdown>
            </div>
          </div>
        </form>

      </div>

    </div>
    <div class="modal-footer" *ngIf="showReject">
      <button class="btn cancel-button" style="margin-left: 1rem" (click)="cancel($event)">
        {{'COMMON.CANCEL' | translate}}
      </button>
      <button class="btn btn-primary" (click)="trySubmitRejection()">
        {{'DATA_QUALITY.SUBMIT_REJECTION' | translate}}
      </button>

    </div>
    <div *ngIf="showApprove" class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="submitApproval()">
        {{'COMMON.YES' | translate}}
      </button>
      <button type="button" (click)="cancel($event)" class="btn cancel-button">
        {{'COMMON.NO' | translate}}
      </button>
    </div>
  </div>
</div>